import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

interface ComingSoonProps {
  title?: string;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ title = 'Coming Soon' }) => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          gap: 3,
        }}
      >
        <ConstructionIcon sx={{ fontSize: 80, color: 'primary.main', opacity: 0.7 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This feature is currently under development and will be available soon.
        </Typography>
      </Box>
    </Container>
  );
};
